import { RadioGroupOrientation as FluentRadioGroupOrientation } from "@fluentui/web-components";
/** Orientation values for {@link RadioGroup}. */
export const RadioGroupOrientations = {
    ...FluentRadioGroupOrientation
};
/**
 * Radio group event names.
 */
export const RadioGroupEventNames = {
    change: "change"
};
//# sourceMappingURL=radio-group.options.js.map